import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusesSection } from './components/BonusesSection';
import { ValueSection } from './components/ValueSection';
import { AuthorSection } from './components/AuthorSection';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';

// Declare fbq on window for TypeScript
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel (safe loader — appends to <head> instead of
    // relying on an existing <script> tag being present in the DOM)
    if (!window.fbq) {
      const n: any = function (...args: unknown[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      window.fbq = n;
      window._fbq = n;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      (document.head || document.documentElement).appendChild(script);
    }
    window.fbq('init', '1379391876531260');
    window.fbq('init', '528129859587075');
    window.fbq('track', 'PageView');
    window.fbq('track', 'ViewContent');
  }, []);
  return <div className="min-h-screen bg-primary text-gray-100 font-body selection:bg-violet/30 selection:text-white" data-id="element-0" data-mp="nvj4bi5joiqs">
      <UrgencyBar data-id="element-1" data-mp="sudlkfnv5z8s" />
      <Hero data-id="element-2" data-mp="studrrrxgr8h" />
      <TrustBar data-id="element-3" data-mp="stc864jdl0nw" />
      <PainSection data-id="element-4" data-mp="sssq8ntq6c9v" />
      <SolutionSection data-id="element-5" data-mp="swgkjp6zv2pn" />
      <BonusesSection data-id="element-6" data-mp="3688rpx40wyp" />
      <ValueSection data-id="element-7" data-mp="35gmj5pekbl3" />
      <AuthorSection data-id="element-8" data-mp="34x29ica5b3w" />
      <Testimonials data-id="element-9" data-mp="38b5stwojqcx" />
      <Guarantee data-id="element-10" data-mp="3ud1ftael3qb5" />
      <FAQ data-id="element-11" data-mp="3udkmfuysas9v" />
      <FinalCTA data-id="element-12" data-mp="3ubriinfk2m5k" />
      <Footer data-id="element-13" data-mp="3uc9inv5c9kir" />
      <FloatingCTA data-id="element-14" data-mp="3uevpttobhy0g" />
    </div>;
}